import reducer from './reducers';

export { default as adminActions } from './actions';
export { default as adminSagas } from './sagas';

export default reducer;



// WEBPACK FOOTER //
// ./src/state/modules/admin/index.js